import ContentContainerBox from "components/stocks/ContentContainerBox";
import type { ReactNode } from "react";

interface DiscussionsContainerProps {
  children: ReactNode;
}

export default function DiscussionsContainer({ children }: DiscussionsContainerProps) {
  return <ContentContainerBox className="p-0 sm:px-0">{children}</ContentContainerBox>;
}
